import type { Suppression } from '../types';
import type { Detection } from '../types/detection';

export type DetectionGroupEvent = {
  type: 'detection' | 'suppression';
  record: Detection | Suppression;
};

export const buildDetectionGroupEvents = (
  detections: Detection[],
  suppressions: Suppression[],
): DetectionGroupEvent[] => {
  const detectionEvents: DetectionGroupEvent[] = detections.map((detection) => ({
    type: 'detection' as const,
    record: detection,
  }));
  const suppressionEvents: DetectionGroupEvent[] = suppressions.map((suppression) => ({
    type: 'suppression' as const,
    record: suppression,
  }));

  return [...detectionEvents, ...suppressionEvents].sort(
    (a, b) => b.record.createdAt.toMillis() - a.record.createdAt.toMillis(),
  );
};
